<template>
  <div class="fosoftech-test-page">
    <div class="test-header">
      <button class="back-btn" @click="goBack">
        <span class="iconfont icon-xiangyou3" style="transform: rotate(180deg);"></span>
        返回首页
      </button>
      <h2 class="test-title">组件测试页面</h2>
    </div>
    
    <div class="test-content">
      <FosoftechBrand />
    </div>
  </div>
</template>

<script>
import FosoftechBrand from './FosoftechBrand.vue'

export default {
  name: 'FosoftechTest',
  components: {
    FosoftechBrand
  },
  methods: {
    goBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.fosoftech-test-page {
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 20px;
}

.test-header {
  /* max-width: 1200px; */
  margin: 0 auto 40px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: #422C27;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background-color: #E4CEC2;
  color: #333;
  transform: translateX(-3px);
}

.test-title {
  font-size: 24px;
  color: #422C27;
  margin: 0;
  font-weight: bold;
}

.test-content {
  max-width: 1800px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  /* background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 40px; */
}

/* @media (max-width: 768px) {
  .test-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .test-content {
    padding: 20px;
  }
  
  .test-title {
    font-size: 20px;
  }
} */
</style>
